// src/components/ObjectiveBoard/KanbanColumn.js
// --- MODIFIED FILE ---
import React, { useEffect, useRef } from "react";
import ObjectiveCard from "./ObjectiveCard"; // Le composant de carte

const KanbanColumn = ({
  status,
  title,
  objectives,
  handleDragOver,
  handleDrop,
  editing,
  handleEditingChange,
  handleEditingBlur,
  handleSelectChange,
  enableEditing,
  getOwnerInitials,
  viewMode,
  getProjectName,
  getProjectPriorityInfo,
  navigate,
  getSprintName,
  sprintOptions,
  allSprints,
  employees,
  getOwnerName,
  openCommentPopup,
  handleDeleteObjective,
  handleDragStart,
  onRequestSuggestion,
  onUpdateObjective, // --- NOUVEAU ---
  onToggleSubscription,
  currentUserId,
  totalObjectives,
  hasMore,
  onLoadMore,
  isSearchActive
}) => {
  const sentinelRef = useRef(null);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || !onLoadMore || isSearchActive || !hasMore) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            onLoadMore();
          }
        });
      },
      { root: null, rootMargin: "200px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore, isSearchActive]);

  const visibleCount = objectives.length;

  return (
    <div
      className="flex min-w-[240px] flex-1 basis-0 flex-col rounded-2xl border border-slate-100 bg-slate-50/70 p-4 shadow-inner xl:min-w-[260px] 2xl:min-w-[300px]"
      onDragOver={handleDragOver}
      onDrop={(e) => handleDrop(e, status)}
    >
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-base font-semibold text-slate-900">{title}</h2>
        <span className="text-xs font-medium text-slate-500">
          {visibleCount}
          {typeof totalObjectives === "number" ? ` / ${totalObjectives}` : ""}
        </span>
      </div>

      <div className="mt-4 space-y-3">
        {objectives.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-slate-200 bg-white/70 py-6 text-center text-sm text-slate-400">
            Aucun objectif
          </div>
        ) : (
          objectives.map((objective) => (
            <ObjectiveCard
              key={objective.id}
              objective={objective}
              editing={editing}
              handleEditingChange={handleEditingChange}
              handleEditingBlur={handleEditingBlur}
              handleSelectChange={handleSelectChange}
              enableEditing={enableEditing}
              getOwnerInitials={getOwnerInitials}
              viewMode={viewMode}
              getProjectName={getProjectName}
              getProjectPriorityInfo={getProjectPriorityInfo}
              navigate={navigate}
              getSprintName={getSprintName}
              sprintOptions={sprintOptions.filter((s) => s.project_id === objective.project_id)}
              allSprints={allSprints}
              employees={employees}
              getOwnerName={getOwnerName}
              openCommentPopup={openCommentPopup}
              handleDeleteObjective={handleDeleteObjective}
              handleDragStart={handleDragStart}
              onRequestSuggestion={onRequestSuggestion}
              onUpdateObjective={onUpdateObjective} // --- NOUVEAU ---
              onToggleSubscription={onToggleSubscription}
              currentUserId={currentUserId}
            />
          ))
        )}

        {!isSearchActive && hasMore && (
          <div ref={sentinelRef} className="h-6 text-center text-xs text-slate-400">
            Chargement...
          </div>
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;
